import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { FCMContext } from "./FCMContext";

export const useFCM = () => {
  const context = useContext(FCMContext);

  if (!context) {
    throw new HookOutOfContextError("useFCM", "FCMContext");
  }

  return context;
};
